import React, { useMemo } from "react";

import { LockOutlined } from "@mui/icons-material";
import ReportIcon from "@mui/icons-material/Report";
import { Box } from "@mui/material";

import Tooltip_ from "..";

import QuestionIcon from "./QuestionIcon";

// можно модифицировать компонент, чтобы он принимал тип от которого зависит иконка
// в этом пока нет необходимости. Важно чтобы иконка определялась именно в этом компоненте,
// а не передавалась от родителя, такое возможно только в качестве исключения
// ----------------------------------------------------------------
const TooltipIcon = ({ tooltip, type, iconProps, sxIconBox, ...rest }) => {
  const Icon = useMemo(() => {
    switch (type) {
      case "lock":
        return LockOutlined;
      case "warning":
        return ReportIcon;
      default:
        return QuestionIcon;
    }
  });
  return (
    <Tooltip_ title={tooltip} disableInteractive {...rest} style={{ height: "18px" }}>
      <Box sx={{ 
        display: "inline-flex",
        height: "100%",
        alignItems: "center",
        cursor: "pointer",
        ...sxIconBox
      }} 
         >
        <Icon {...iconProps} />
      </Box>
    </Tooltip_>
  );
};

export default TooltipIcon;
